<template>
  <form :class="[grid, gap, width, height, space]" @submit.prevent="emit('submit')">
    <slot />
  </form>
</template>

<script lang="ts" setup>
  const emit = defineEmits(["submit"]);

  defineProps({
    grid: {
      type: [String, Array, Object],
      default: "grid grid-cols-12",
    },
    gap: {
      type: [String, Array, Object],
      default: "gap-4",
    },
    width: {
      type: [String, Array, Object],
      default: "",
    },
    space: {
      type: [String, Array, Object],
      default: "",
    },
    height: {
      type: [String, Array, Object],
      default: "",
    },
  });
</script>
